import { jsx as _jsx } from "react/jsx-runtime";
const TableContainer = ({ children, hasMaximumHeight = true, }) => {
    return (_jsx("div", Object.assign({ className: "overflow-auto w-100", style: { maxHeight: hasMaximumHeight ? "600px" : "none" } }, { children: children })));
};
export default TableContainer;
